import PageLoadAnimation from "../page-load-animation";

class FormAnimatedGroup {
    constructor() {
        this._init()
    }
    _init() {
        const pageLoadAnimation = new PageLoadAnimation(false);
        // data-form-animated-group
        // data-form-animated-group-item

        document.querySelectorAll('[data-form-animated-group]').forEach(elForm => {

            elForm.addEventListener('submit', (event) => {

                if (event.target && !event.target.matches('[data-form-animated-group-item]')) {
                    return;
                }

                pageLoadAnimation.toggleLoading(true);
            });
        });
    }
}

export default FormAnimatedGroup